export const openFaqDialog = {
    type: 'OPEN_FAQ_DIALOG',
};

export const closeFaqDialog = {
    type: 'CLOSE_FAQ_DIALOG',
};
